import React from "react";
import { Input as AriaInput, type InputProps } from "react-aria-components";
import {
  InputBuilder,
  type InputBuilderProps as DSInputProps,
} from "./shared/InputBuilder.tsx";
import { extractInputBuilderProps } from "./shared/inputBuilderHelper.ts";
import type { OmittedReactAriaProps } from "./types.ts";

export type Props = Omit<InputProps, OmittedReactAriaProps | "size"> &
  DSInputProps & {
    /** Ref to the underlying input element. */
    ref?: React.Ref<HTMLInputElement>;
  };

/**
 * A styled text input field with support for icons, loading states, and leading text.
 * Built on react-aria Input for accessibility.
 */
export const Input: React.FC<Props> = ({ ref, ...props }) => {
  const { inputBuilderProps, restProps } = extractInputBuilderProps(props);

  return (
    <InputBuilder {...inputBuilderProps}>
      <AriaInput ref={ref} {...restProps} />
    </InputBuilder>
  );
};
